











import { Component, Vue } from "vue-property-decorator";
import { getters as gettersGlobal } from "@/observables/Global";
import Chart from "./Chart/Chart.vue";
import Summary from "./Summary/Summary.vue";

@Component({ components: { Chart, Summary } })
export default class Main extends Vue {
  /* Computed */
  get viewMode(): string {
    return gettersGlobal.getViewMode();
  }
}
